module.exports = __webpack_public_path__ + "img/circle_bg.400fb2e2.webp";